import React from "react";
import SingleSite from "./SingleSite";
import { Spinner, SpinnerSize, Pivot, PivotItem } from "@fluentui/react";
import SingleTask from "./SingleTask";
import SingleQARTask from "./SingleQARTask";
import OwnerSearch from "./OwnerSearch";
import Api from "../../services/Api";
import axios from "axios";
import PageNavi from "../Administration/PageNavi";
import { Stack } from "@fluentui/react";
//import DeliveryCenterButton from "./DeliveryCenterButton";

class MySites extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: {
        sites: false,
        teams: false,
        newSites: false,
        changes: false,
        qars: false,
      },
      sites: {
        results: [],
        totalCount: 0,
        page: 1,
        onPage: 100,
      },
      teams: {
        results: [],
        totalCount: 0,
        page: 1,
        onPage: 100,
      },
      newSites: {
        results: [],
      },
      changes: [],
      changeTypes: null,
      changeTypesLoaded: false,
      qars: [],
      isNotificationOnly: false,
    };
  }

  downloadData() {
    this.getChangeTypes();
    this.getSites("owner", "sites");
    this.getSites("teamsOwner", "teams");
    this.getSites("approver", "newSites");
    this.getChangeTasks("approver");
    this.getQARTasks("approver");
  }

  componentDidMount() {
    this.axiosCancelSource = axios.CancelToken.source();

    this.downloadData();
  }

  componentWillUnmount() {
    this.axiosCancelSource.cancel();
  }

  getSites(filterBy, results) {
    this.setState((prevState) => ({
      isLoading: {
        ...prevState.isLoading,
        [results]: true,
      },
    }));

    let url = `/SitesPanel?filterBy=${filterBy}`;
    if (this.state[results].page) {
      url += `&page=${this.state[results].page}&onPage=${this.state[results].onPage}`;
    }

    Api.get(url, {
      cancelToken: this.axiosCancelSource.token,
    })
      .then((res) => res.data)
      .then((sitesResults) => {
        //exclude Pernamently deleted status in Manage Center, it's visible only in Administration tab
        const filteredResults = sitesResults.results.filter(
          (site) => site.siteStatus !== "Pernamently Deleted"
        );
        console.log(filteredResults);
        this.setState((prevState) => ({
          isLoading: {
            ...prevState.isLoading,
            [results]: false,
          },
          [results]: {
            ...prevState[results],
            results: filteredResults,
            totalCount: filteredResults.length,
          },
        }));
      })
      .catch((error) => {
        this.setState((prevState) => ({
          isLoading: { ...prevState.isLoading, [results]: false },
        }));
        console.log(error);
      });
  }

  getChangeTasks(filterBy) {
    this.setState((prevState) => ({
      isLoading: {
        ...prevState.isLoading,
        tasks: true,
      },
    }));

    Api.get(`/ApproverTasks?filterBy=${filterBy}&includeGroupTasks=true`, {
      cancelToken: this.axiosCancelSource.token,
    })
      .then((res) => res.data)
      .then((sites) => {
        this.setState((prevState) => ({
          isLoading: {
            ...prevState.isLoading,
            changes: false,
          },
          changes: sites,
        }));
      })
      .catch((error) => {
        this.setState((prevState) => ({
          isLoading: { ...prevState.isLoading, [filterBy]: false },
        }));
        console.log(error);
      });
  }

  getQARTasks(filterBy) {
    this.setState((prevState) => ({
      isLoading: {
        ...prevState.isLoading,
        qars: true,
      },
    }));

    Api.get(`/QARTasks?filterBy=${filterBy}`, {
      cancelToken: this.axiosCancelSource.token,
    })
      .then((res) => res.data)
      .then((sites) => {
        this.setState((prevState) => ({
          isLoading: {
            ...prevState.isLoading,
            qars: false,
          },
          qars: sites,
        }));
      })
      .catch((error) => {
        this.setState((prevState) => ({
          isLoading: { ...prevState.isLoading, [filterBy]: false },
        }));
        console.log(error);
      });
  }

  getChangeTypes() {
    Api.get(`/ChangeType?p=1`, {
      cancelToken: this.axiosCancelSource.token,
    })
      .then((res) => res.data)
      .then((sites) => {
        this.setState((prevState) => ({
          changeTypes: sites,
          changeTypesLoaded: true,
        }));
      })
      .catch((error) => {
        console.log(error);
      });
  }
  refresh() {
    this.downloadData();
  }

  getSiteById = async (id) => {
    const result = await Api.get(`/Site?id=${id}`);

    return result.data;
  };

  onEditCallback = async (id, data) => {
    const site = await this.getSiteById(id);

    const items = this.state[data].results;
    const updatedItems = items.map((x) => (x.id === id ? site : x));

    this.setState({ [data]: { ...this.state[data], results: updatedItems } });
  };

  // onCallBack (value, data)
  // {
  //     let sites = this.state[data];
  //     for(let i = 0; i< sites.length; i++)
  //     {
  //         if(sites[i].id === value)
  //         {
  //             sites[i].provisioningStatus = ProvisioningStatus.updating;
  //             break;
  //         }
  //     }
  //     this.setState({[data]: sites});
  // }

  combineTasks() {
    let tasks = [];
    const newSites = this.state.newSites.results.map((member) => {
      return {
        ...member,
        label: "createTask",
      };
    });

    const changes = this.state.changes.map((member) => {
      return {
        ...member,
        label: member.type,
      };
    });

    newSites.map((x) => tasks.push(x));
    changes.map((x) => tasks.push(x));

    return tasks.sort(
      (a, b) =>
        new Date(b.created || b.requestDate) -
        new Date(a.created || a.requestDate)
    );
  }

  getUrlParams(paramName) {
    let url_string = window.location.href;
    let url = new URL(url_string);
    let paramValue = url.searchParams.get(paramName);
    return paramValue;
  }

  getQarTaskFromUrl() {
    const qarTaskId = this.getUrlParams("qarTaskId");
    return qarTaskId
      ? this.state.qars.find((x) => x.id === Number(qarTaskId))
      : null;
  }

  setPageUrlFilter = (results, filterBy, value) => {
    this.setState(
      {
        [results]: {
          ...this.state[results],
          page: value,
        },
      },
      () => {
        this.getSites(filterBy, results);
      }
    );
  };

  getPageNavi(results, filterBy) {
    return (
      this.state[results].totalCount > this.state[results].onPage && (
        <div style={{ flexBasis: "100%" }}>
          <PageNavi
            pageNumPart={(value) =>
              this.setPageUrlFilter(results, filterBy, value)
            }
            resultsOnPage={this.state[results].onPage}
            pageNum={this.state[results].page}
            totalResults={this.state[results].totalCount}
          />
        </div>
      )
    );
  }

  render() {
    const mySites = this.state.sites.results.map((s) => (
      <SingleSite
        key={s.id}
        site={s}
        callBack={(id) => this.onEditCallback(id, "sites")}
      />
    ));

    const myQARTasks = this.state.qars.map((s) => (
      <SingleQARTask key={s.id} element={s} refresh={this.refresh.bind(this)} />
    ));

    const myTasks = this.combineTasks().map((s) => (
      <SingleTask
        key={s.id + s.label}
        element={s}
        refresh={this.refresh.bind(this)}
      />
    ));

    const myQARandTasks = [...myQARTasks, ...myTasks];

    const myTeams = this.state.teams.results.map((s) => (
      <SingleSite
        key={s.id}
        site={s}
        callBack={(id) => this.onEditCallback(id, "teams")}
      />
    ));
    const spinner = (
      <Spinner style={{ margin: "200px" }} size={SpinnerSize.large} />
    );
    const defaultSelectedKey = window.location.hash
      ? window.location.hash.substr(1)
      : "MySites";

    const qarTask = this.getQarTaskFromUrl();
    const qarTaskDialog = qarTask && (
      <SingleQARTask
        key={qarTask.id + qarTask.label}
        element={qarTask}
        showDialog={true}
        refresh={this.refresh.bind(this)}
      />
    );

    const sitesPageNavi = this.getPageNavi("sites", "owner");
    const teamsPageNavi = this.getPageNavi("teams", "teamsOwner");

    return (
      <div
        style={{
          backgroundColor: "#F8F8F8",
          minHeight: "500px",
          padding: "20px 20px 20px 20px",
          minWidth: "850px",
        }}>
        {qarTaskDialog}
        <Stack horizontal reversed>
          {/* <DeliveryCenterButton></DeliveryCenterButton> */}
        </Stack>
        <Pivot styles={pivotStyles} defaultSelectedKey={defaultSelectedKey}>
          <PivotItem
            itemKey="MySites"
            headerText="My SharePoint Sites"
            itemCount={this.state.sites.totalCount}
            style={pivotItemStyles}>
            {this.state.isLoading.sites ? (
              spinner
            ) : (
              <div style={pivotItemStyles}>
                {mySites}
                {sitesPageNavi}
              </div>
            )}
          </PivotItem>
          <PivotItem
            itemKey="MyTeams"
            headerText="My Teams"
            itemCount={this.state.teams.totalCount}
            style={pivotItemStyles}>
            {this.state.isLoading.teams ? (
              spinner
            ) : (
              <div style={pivotItemStyles}>
                {myTeams}
                {teamsPageNavi}
              </div>
            )}
          </PivotItem>
          <PivotItem
            itemKey="MyTasks"
            headerText="My Tasks"
            itemCount={myQARandTasks.length}
            style={pivotItemStyles}>
            {this.state.isLoading.newSites || this.state.isLoading.changes
              ? spinner
              : myQARandTasks}
          </PivotItem>
          <PivotItem itemKey="OwnerSearch" headerText="Owner search">
            {<OwnerSearch />}
          </PivotItem>
        </Pivot>
      </div>
    );
  }
}

const pivotStyles = {
  root: {
    marginBottom: 20,
  },
  linkContent: {
    fontSize: 16,
    flex: "auto",
  },
};

const pivotItemStyles = {
  display: "flex",
  flexWrap: "wrap",
};

export default MySites;



// WEBPACK FOOTER //
// ./src/components/ManageCenter/MySites.js